import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import { getProviderMenus } from "../../contexts/ProviderMenus";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";

const ProviderSubscriptions = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { t } = useTranslation();
  const menus = getProviderMenus();

  const bundles = [
    {
      id: 1,
      name: t("providerSubscriptions.bundles.basic.name"),
      description: t("providerSubscriptions.bundles.basic.description"),
      price: 50,
      image: "https://picsum.photos/400/200?random=5",
      options: [
        t("providerSubscriptions.bundles.basic.options.0"),
        t("providerSubscriptions.bundles.basic.options.1"),
      ],
    },
    {
      id: 2,
      name: t("providerSubscriptions.bundles.advanced.name"),
      description: t("providerSubscriptions.bundles.advanced.description"),
      price: 100,
      image: "https://picsum.photos/400/200?random=6",
      options: [
        t("providerSubscriptions.bundles.advanced.options.0"),
        t("providerSubscriptions.bundles.advanced.options.1"),
        t("providerSubscriptions.bundles.advanced.options.2"),
      ],
    },
    {
      id: 3,
      name: t("providerSubscriptions.bundles.premium.name"),
      description: t("providerSubscriptions.bundles.premium.description"),
      price: 200,
      image: "https://picsum.photos/400/200?random=7",
      options: [
        t("providerSubscriptions.bundles.premium.options.0"),
        t("providerSubscriptions.bundles.premium.options.1"),
        t("providerSubscriptions.bundles.premium.options.2"),
        t("providerSubscriptions.bundles.premium.options.3"),
      ],
    },
  ];

  return (
    <div className="flex">
      <DashboardSidebarMenu title={t("admin.title")} menus={menus} />
      <div className="container mx-auto px-6 py-12 flex text-onWhite">
        {/* Contenu principal */}
        <div className="w-full">
          <h2 className="text-2xl font-bold mb-4 text-center">
            {t("providerSubscriptions.pageTitle")}
          </h2>
          <p className="text-gray-600 mb-10 text-center">
            {t("providerSubscriptions.pageDescription")}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {bundles.map((bundle) => (
              <div
                key={bundle.id}
                className="border rounded-xl shadow-md flex flex-col items-center bg-white hover:shadow-lg transition cursor-pointer hover:scale-105 transform transition duration-300 border-gray-300"
              >
                {/* Image */}
                <img
                  src={bundle.image}
                  alt={bundle.name}
                  className="w-full h-40 object-cover rounded-t-lg mb-4"
                  loading="lazy"
                />
                {/* Title */}
                <h3 className="text-lg font-bold text-center mb-2">
                  {bundle.name}
                </h3>
                {/* Price */}
                <p className="font-semibold text-xl mb-3">
                  ${bundle.price} / {t("calendar.month").toLowerCase()}
                </p>
                {/* Options */}
                <div className="w-full">
                  {bundle.options.map((option, index) => (
                    <div
                      key={index}
                      className="flex items-start gap-4 mb-4 mx-8"
                    >
                      <div className="flex-shrink-0 ">
                        <CheckIcon className="text-primary h-4 w-4 mt-1" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-600 text-left max-w-xs mx-auto">
                          {option}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Contact Button */}
                <button
                  onClick={() => setIsPopupOpen(true)}
                  className="bg-primary text-white px-4 py-2 rounded-full hover:bg-primary/90 transition mt-auto mb-4"
                >
                  {t("providerSubscriptions.contactButton")}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Popup de contact */}
        {isPopupOpen && (
          <Dialog
            open={isPopupOpen}
            onClose={() => setIsPopupOpen(false)}
            className="fixed inset-0 z-50 flex items-center justify-center text-onWhite"
          >
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative">
              <h2 className="text-lg font-bold mb-4">
                {t("providerSubscriptions.popup.title")}
              </h2>
              <p className="text-gray-600 mb-4">
                {t("providerSubscriptions.popup.description")}
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4">
                <li>{t("providerSubscriptions.popup.email")}</li>
                <li>{t("providerSubscriptions.popup.phone")}</li>
              </ul>
              <div className="flex justify-center">
                <button
                  onClick={() => setIsPopupOpen(false)}
                  className="bg-primary text-white px-4 py-2 rounded-full hover:bg-primary/90 transition"
                >
                  {t("providerSubscriptions.popup.closeButton")}
                </button>
              </div>
            </div>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default ProviderSubscriptions;
